import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { deleteBookById } from 'api/auth.api';

export const useBookDelete = ({ onSuccess } = {}) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteBookById,

    onSuccess: (res) => {
      queryClient.invalidateQueries(['bookList']);

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to delete book',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
